import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoot } from './shell/ReadyApp.js';
import { AccountProvider } from './shell/accountContext.js';
import { I18nProvider } from './i18n/index.js';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root element');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AccountProvider>
        <I18nProvider>
          <AppRoot />
        </I18nProvider>
      </AccountProvider>
    </BrowserRouter>
  </StrictMode>,
);
